import { render, staticRenderFns } from "./BarcodePicker.vue?vue&type=template&id=0f9c70b4"
import script from "./BarcodePicker.vue?vue&type=script&lang=js"
export * from "./BarcodePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports